import { render, staticRenderFns } from "./remarkIcon.vue?vue&type=template&id=ab97a128&scoped=true"
import script from "./remarkIcon.vue?vue&type=script&lang=js"
export * from "./remarkIcon.vue?vue&type=script&lang=js"
import style0 from "./remarkIcon.vue?vue&type=style&index=0&id=ab97a128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab97a128",
  null
  
)

export default component.exports